import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export class DashboardWidget {

    static metadata: any = {
        ID: new InjectionToken<string>('id'),
        NAME: new InjectionToken<string>('name'),
        ROUTERLINK: new InjectionToken<string>('routerLink'),
        BACKGROUND_COLOR: new InjectionToken<string>('background_color'),
        COLS: new InjectionToken<number>('cols'),
        ROWS: new InjectionToken<string>('rows'),
        SECTION: new InjectionToken<number>('section'),
        ISSHOW: new InjectionToken<number>('isShow')
    };
    
    static displaySize: any = {
        SMALL : {
            width: 3,
            height: '250px',
        },
        MEDIUM : {
            width: 6,
            height: '500px',
        },
        LARGE : {
            width: 12,
            height: 'auto',
        },
    }

    constructor(
        private _component: any,
        private _input: 
            {
                id: {
                    key: InjectionToken<number>,
                    value: number
                }
                name: {
                    key: InjectionToken<string>,
                    value: string
                },
                routerLink: {
                    key: InjectionToken<string>,
                    value: string
                },
                background_color: {
                    key: InjectionToken<string>,
                    value: string
                },
                cols: {
                    key: InjectionToken<number>,
                    value: number
                },
                rows: {
                    key: InjectionToken<number>,
                    value: string
                },
                section: {
                    key: InjectionToken<number>,
                    value: number
                },
                isShow: {
                    key: InjectionToken<boolean>,
                    value: boolean
                }
            },
    ) {}

    get input(): {
        id: {
            key: InjectionToken<number>,
            value: number
        },
        name: {
            key: InjectionToken<string>,
            value: string
        };
        routerLink: {
            key: InjectionToken<string>,
            value: string
        };
        background_color: {
            key: InjectionToken<string>,
            value: string
        };
        cols: {
            key: InjectionToken<number>,
            value: number
        };
        rows: {
            key: InjectionToken<number>,
            value: string
        },
        section: {
            key: InjectionToken<number>,
            value: number
        },
        isShow: {
            key: InjectionToken<boolean>,
            value: boolean
        }
    } {
        return this._input;
    }

    get component(): any {
        return this._component;
    }

    set Col(col: any){
        this._input.cols.value = col;
    }
    set Row(row: any){
        this._input.rows.value = row;
    }
    set section(section:any){
        this._input.section.value = section;
    }
    set display(isShow:any){
        this._input.isShow.value = isShow;
    }
}